(function() {
    const footerLinkEls = document.body.querySelectorAll('.footer a[href="#"]');

    footerLinkEls.forEach(el => {
        el.addEventListener('click', e => e.preventDefault());
    });
})();
